import { Instance } from '@react-three/fiber/dist/declarations/src/core/renderer';
import { useNearestParent } from 'its-fine';
import { useEffect } from 'react';
import type {
  Material,
  MeshStandardMaterial,
  MeshStandardMaterialParameters,
} from 'three';

import { resolve } from 'lib/r3f';

const isMeshStandardMaterial = (mat: Material): mat is MeshStandardMaterial => {
  return (mat as MeshStandardMaterial).isMeshStandardMaterial;
};

type Props = {
  attach: string;
} & MeshStandardMaterialParameters;

export const ModifyMaterial = ({ attach, ...props }: Props) => {
  const parentMesh = useNearestParent<Instance>();

  // store original texture
  useEffect(() => {
    if (!parentMesh.current) {
      return;
    }
    const { target, key } = resolve(parentMesh.current, attach);
    const material = target[key];
    if (!isMeshStandardMaterial(material)) {
      // eslint-disable-next-line no-console
      console.error(
        'Expected a meshStandardMaterial at',
        attach,
        'got',
        material
      );
      return;
    }

    (Object.keys(props) as (keyof typeof props)[]).forEach(k => {
      // @ts-expect-error wrong type assumes format is not valid
      material[k] = props[k];
    });
    material.needsUpdate = true;
  }, [attach, parentMesh, props]);

  return null;
};
